import { api } from "../utils/api";
import type { RestChain, RestUpdateChain } from "@KassaroAB/shared/types/chain";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const getChainsApi = async (): Promise<RestChain[]> => {
  return api.get(`chains`);
};

export const getChainsPaginatedApi = async (cursor: string | null, limit: number = 20): Promise<RestChain[]> => {
  const params = new URLSearchParams();
  if (cursor) {
    params.set('cursor', cursor);
  }
  params.set('limit', limit.toString());
  return api.get(`admin/chains?${params.toString()}`);
};

export const getChainApi = async (chainId: ChainId): Promise<RestChain> => {
  return api.get(`chains/${chainId}`);
};

export const updateChainApi = async (
  chainId: ChainId,
  chain: RestUpdateChain,
): Promise<RestChain> => {
  return api.put(`/chains/${chainId}`, chain);
};
